'use client';

import { LogoBjLink } from '@components/layout';

/**
 * @description Login Header
 * - This component is used in the login page.
 */
export const AuthHeader = ({locale}: {locale?: Locale}) => (
  <div className="mb-4 mt-3 flex h-8 justify-start md:mb-6 md:mt-5 2xl:mb-9 2xl:mt-8">
    <LogoBjLink
      locale={locale}
      className="h-8 w-auto"
      showFullLogo
    />
  </div>
);
